var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _path, _path2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTaxi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 210 210",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b,.n{fill:#00263d;}.b{clip-rule:evenodd;}.c{clip-path:url(#a);}.d{fill:#fdb338;}.e{clip-path:url(#b);}.f{clip-path:url(#c);}.g{clip-path:url(#d);}.h{clip-path:url(#e);}.i{clip-path:url(#f);}.j{clip-path:url(#g);}.k{clip-path:url(#h);}.l{clip-path:url(#i);}.m{clip-path:url(#j);}.n{fill-rule:evenodd;}.o{clip-path:url(#k);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 137.84,
    y: 127.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 132.84,
    y: 133.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 125.84,
    y: 127.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 120.84,
    y: 133.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 114.84,
    y: 127.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 109.84,
    y: 133.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 102.84,
    y: 127.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 81.84,
    y: 127.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 69.84,
    y: 127.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 74.84,
    y: 133.7,
    width: 5,
    height: 5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M162.73,155.7a12.92,12.92,0,0,1-10.22-5l-.47-.61H67.25l-.48.61a13,13,0,0,1-20.42,0l-.48-.61h-18a1.34,1.34,0,0,1-1.17-.7L21,138.23a1.15,1.15,0,0,1-.11-.77l2.87-14a1.27,1.27,0,0,1,.92-1L44.55,117l12.09-7.06a71.54,71.54,0,0,1,27.14-9.23l1.06-.13,2-7.91a1.27,1.27,0,0,1,1.25-.94H99.6a1.27,1.27,0,0,1,1.25.94l2.09,8.16,1,.15a72.53,72.53,0,0,1,18.61,5.48l23.28,10.48,27.77,3.31a18.72,18.72,0,0,1,16.2,18.48v7.38a1.26,1.26,0,0,1-1.08,1.22l-15.12,2.45-.39.54A12.88,12.88,0,0,1,163,155.7Zm0-22.38a10.54,10.54,0,0,0-3.88.75,9.94,9.94,0,0,0-6.3,9.21,10.23,10.23,0,0,0,19.6,3.82,9.8,9.8,0,0,0-2.21-10.87A10.26,10.26,0,0,0,162.72,133.32Zm-106.16,0a10.56,10.56,0,0,0-3.89.75,10,10,0,0,0-6.3,9.21A10.23,10.23,0,0,0,66,147.1a9.79,9.79,0,0,0-2.21-10.87A10.26,10.26,0,0,0,56.56,133.32ZM55,126.22l2.39,4.64.82.11a12.38,12.38,0,0,1,10.89,14.79l-.4,1.89H92.57V119.34H55ZM28.67,147.65H44.44l-.39-1.89a11.85,11.85,0,0,1,0-5l.39-1.88H24.2Zm66.48,0h55.46l-.4-1.89a12.18,12.18,0,0,1,2.46-10.18,12.9,12.9,0,0,1,9.61-4.74h.44a13,13,0,0,1,9.48,4.1,12.2,12.2,0,0,1,3.18,10l-.3,2.11,12.18-2V138.7a16.39,16.39,0,0,0-14.08-16.06l-27.65-3.29H95.15Zm-69-23L23.7,136.46H45.87l.48-.62a12.73,12.73,0,0,1,6.37-4.4l1.79-.56-2-3.84a1.13,1.13,0,0,1-.13-.54v-7.16H45.27Zm69-7.8h38.16l.57-2.64-12.39-5.58a70,70,0,0,0-24.67-6l-1.67-.09ZM91,102.59A69.58,69.58,0,0,0,58,112l-8.32,4.88H92.57V102.54Zm2-2.49c1.59,0,3.24.06,5,.18l2.18.15-1.61-6.27H89.14l-1.56,6.1,2.12-.09C90.8,100.12,91.89,100.1,93,100.1Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 132.84,
    y: 122.7,
    width: 15,
    height: 15
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 127.84,
    y: 128.7,
    width: 15,
    height: 15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 120.84,
    y: 122.7,
    width: 15,
    height: 15
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 115.84,
    y: 128.7,
    width: 15,
    height: 15
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 109.84,
    y: 122.7,
    width: 15,
    height: 15
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 104.84,
    y: 128.7,
    width: 15,
    height: 15
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 97.84,
    y: 122.7,
    width: 15,
    height: 15
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 76.84,
    y: 122.7,
    width: 15,
    height: 15
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 64.84,
    y: 122.7,
    width: 15,
    height: 15
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 69.84,
    y: 128.7,
    width: 15,
    height: 15
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M93.83,87.75,79.76,69.54l-.38-.47a14.18,14.18,0,0,1-2.62-10.58A15,15,0,0,1,82.5,49a18.21,18.21,0,0,1,11.34-3.56A18.21,18.21,0,0,1,105.18,49a15.07,15.07,0,0,1,5.74,9.47,14.18,14.18,0,0,1-2.5,10.41Zm0-39.79A15.74,15.74,0,0,0,84,51a12.54,12.54,0,0,0-4.81,7.89,11.64,11.64,0,0,0,2.13,8.66l.31.38.09.12L93.84,83.66,106.4,67.42a11.63,11.63,0,0,0,2-8.54A12.58,12.58,0,0,0,103.64,51,15.79,15.79,0,0,0,93.84,48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M162.73,155.7a12.92,12.92,0,0,1-10.22-5l-.47-.61H67.25l-.48.61a13,13,0,0,1-20.42,0l-.48-.61h-18a1.34,1.34,0,0,1-1.17-.7L21,138.23a1.15,1.15,0,0,1-.11-.77l2.87-14a1.27,1.27,0,0,1,.92-1L44.55,117l12.09-7.06a71.54,71.54,0,0,1,27.14-9.23l1.06-.13,2-7.91a1.27,1.27,0,0,1,1.25-.94H99.6a1.27,1.27,0,0,1,1.25.94l2.09,8.16,1,.15a72.53,72.53,0,0,1,18.61,5.48l23.28,10.48,27.77,3.31a18.72,18.72,0,0,1,16.2,18.48v7.38a1.26,1.26,0,0,1-1.08,1.22l-15.12,2.45-.39.54A12.88,12.88,0,0,1,163,155.7Zm0-22.38a10.54,10.54,0,0,0-3.88.75,9.94,9.94,0,0,0-6.3,9.21,10.23,10.23,0,0,0,19.6,3.82,9.8,9.8,0,0,0-2.21-10.87A10.26,10.26,0,0,0,162.72,133.32Zm-106.16,0a10.56,10.56,0,0,0-3.89.75,10,10,0,0,0-6.3,9.21A10.23,10.23,0,0,0,66,147.1a9.79,9.79,0,0,0-2.21-10.87A10.26,10.26,0,0,0,56.56,133.32ZM55,126.22l2.39,4.64.82.11a12.38,12.38,0,0,1,10.89,14.79l-.4,1.89H92.57V119.34H55ZM28.67,147.65H44.44l-.39-1.89a11.85,11.85,0,0,1,0-5l.39-1.88H24.2Zm66.48,0h55.46l-.4-1.89a12.18,12.18,0,0,1,2.46-10.18,12.9,12.9,0,0,1,9.61-4.74h.44a13,13,0,0,1,9.48,4.1,12.2,12.2,0,0,1,3.18,10l-.3,2.11,12.18-2V138.7a16.39,16.39,0,0,0-14.08-16.06l-27.65-3.29H95.15Zm-69-23L23.7,136.46H45.87l.48-.62a12.73,12.73,0,0,1,6.37-4.4l1.79-.56-2-3.84a1.13,1.13,0,0,1-.13-.54v-7.16H45.27Zm69-7.8h38.16l.57-2.64-12.39-5.58a70,70,0,0,0-24.67-6l-1.67-.09ZM91,102.59A69.58,69.58,0,0,0,58,112l-8.32,4.88H92.57V102.54Zm2-2.49c1.59,0,3.24.06,5,.18l2.18.15-1.61-6.27H89.14l-1.56,6.1,2.12-.09C90.8,100.12,91.89,100.1,93,100.1Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 210,
    height: 210
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTaxi);
export default __webpack_public_path__ + "static/media/Icon-taxi.09df61683e06aa1a986d75983d2dc451.svg";
export { ForwardRef as ReactComponent };